<template>
  <div>
    <el-card>
      <el-row :gutter="20">
        <el-col :sm="24" :md="8" :lg="6">
          <el-date-picker
          style="width:100%"
            v-model="searchForm.createTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-col>

        <el-col :sm="24" :md="4" :lg="14" style="text-align:right">
          <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh"  style="text-align:right">重置</el-button> -->

          <!-- <a @click="reset" class="mainColor ml">重置</a> -->
          <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
        </el-col>
      </el-row>
    </el-card>
    <div class="tab-bar">
      <div class="bar-left">
        <div :class="nowIndex==1?'bar-item-visited':'bar-item'" @click="nowIndex=1">开通记录</div>
        <div :class="nowIndex==2?'bar-item-visited':'bar-item'" @click="nowIndex=2">充值记录</div>
      </div>
      <div class="bar-right">
        <span>账户余额:</span>
        <span style="font-weight: 700;">{{userAmount.amount}}</span>&nbsp;&nbsp;&nbsp;
        <span v-if="nowIndex==1">消费合计:</span>
        <span v-if="nowIndex==1" style="font-weight: 700;">{{userAmount.consumptionAmount}}</span>
        <span v-if="nowIndex==2">充值合计:</span>
        <span v-if="nowIndex==2" style="font-weight: 700;">{{userAmount.rechargeAmount}}</span>
      </div>
    </div>

    <el-card class="box-card" style="margin-top: 0px;">
      <el-table
        v-if="nowIndex==1"
        ref="multipleTable"
        :data="page.rows"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        tooltip-effect="dark"
        style="width: 100%;"
        border
      >
        <el-table-column show-overflow-tooltip prop="createTime" label="创建时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="amount" label="金额（元）"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderId" label="订单号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="userName" label="操作人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="消费说明"></el-table-column>
      </el-table>
      <el-table
        v-if="nowIndex==2"
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="width: 100%;"
        border
      >
        <el-table-column show-overflow-tooltip prop="createTime" label="创建时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="amount" label="金额（元）"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderId" label="订单号/交易号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="userName" label="操作人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="充值说明"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      userAmount: {},
      nowIndex: 1,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      options: [],
      searchForm: {
        userIds: [],
        type: "",
        createTime: ""
      },

      formLabelWidth: "80px",
      selection: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/student/upload`,
      fileList: [],
      loading: false
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    getStudent() {
      this.api.student
        .getStudent({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.agentAmountLog
        .pageList(this.searchForm)
        .then(result => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },

    reset() {
      this.searchForm.userIds = [];
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    getAgentAmountStatsDTO() {
      this.api.agentAmountLog
        .getAgentAmountStatsDTO({ id: this.loginData.agentId })
        .then(result => {
          this.userAmount = result.data;
        })
        .catch(error => {
          console.log(error);
        });
      this.api.agentUserInfo
        .getAgentUserInfoList({ agentId: this.loginData.agentId })
        .then(result => {
          this.options = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    nowIndex(val) {
      if (val == 1) {
        this.searchForm.type = "消费";
      } else {
        this.searchForm.type = "充值";
      }
      this.pageList();
    },
    "searchForm.createTime": function(newVal) {
      this.searchForm.createTimeStart = newVal[0];
      this.searchForm.createTimeEnd = newVal[1];
    },
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getStudent();
      }
    },
    viewFormVisible: function(newVal) {
      if (!newVal) {
        // this.$refs.editForm.resetFields();
        // this.pageList();
      } else {
        this.getStudent();
      }
    }
  },
  mounted() {
    this.pageList();
    this.getAgentAmountStatsDTO();
  }
};
</script>
<style lang="less" scoped>
.el-select {
  width: 100% !important;
}
.tab-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  background: rgb(246, 249, 250);
  padding-top: 10px;
  .bar-right {
    height: 40px;
    padding-right: 10px;
    span {
      color: #455a64;
      text-align: right;
      line-height: 40px;
      font-size: 16px;
    }
  }
  .bar-left {
    display: flex;
    flex-direction: row;
    .bar-item {
      font-size: 14px;
      color: #455a64;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      text-align: center;
      width: 100px;
    }
    .bar-item-visited {
      font-size: 14px;
      color: rgb(77, 148, 255);
      height: 40px;
      text-align: center;
      width: 100px;
      cursor: pointer;
      line-height: 40px;
      background: #ffffff;
    }
    .bar-item:hover {
      font-size: 14px;
      text-align: center;
      cursor: pointer;
      color: rgb(77, 148, 255);
      height: 40px;
      width: 100px;
      line-height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/openRecord/index.vue